import React, { useEffect, useState } from 'react';

// Components
import BaseContentContainer from '../../components/base-content-container/base-content-container';
import ButtonsBar from '../../components/buttons-bar/buttons-bar';
import Empty from '../../components/empty/empty';
import ErrorComponent from '../../components/error/error';
import FeatureTitle from '../../components/feature-title/feature-title';
import List from '../../components/list/list';
import Loading from '../../components/loading/loading';

// Models
import {
  BaseContentContainerActionButtonPosition,
  BaseContentContainerFormat,
} from '../../models/base-content-container';


// Services
import ChatService from '../../services/chat-service';

const chatService = new ChatService();

const isNullOrUndefined = (value) => {
  return value === undefined || value === null;
}

const formatDate = (rawDate: string) => {
  const date = new Date(rawDate);
  const now = new Date();
  const today = date.getDate() === now.getDate();
  const dateTimeString = date.toLocaleString('pt-br');
  const timeString = date.toLocaleTimeString('pt-br', { hour: "2-digit", minute: "2-digit" });

  return today ? `Hoje às ${timeString}` : dateTimeString;
}

const ChatList = () => {

  const titles: ListContentTitle[] = [
    { text: 'Responsável' },
    { text: 'Não Lidas' },
    { text: 'Última mensagem' },
    { text: 'Data', align: 'right' },
  ];

  const [error, setError] = useState(false);
  const [chatList, setNoticeBoardList] = useState<ListContent[]>(null);
  useEffect(() => {
    chatService
      .listChatSummary()
      .then((chatSummaryList) => {
        const newNoticeBoardList = [];

        chatSummaryList.forEach((chatSummary) => {
          const noticeBoardItem: ListContent = {
            linkTo: `/mensagens/${chatSummary.chatId}`,
            data: [
              {
                text: chatSummary.responsibleName,
                customStyle: { maxWidth: '250px' },
              },
              {
                text: !isNullOrUndefined(chatSummary.unreadMessageCount) ?
                  chatSummary.unreadMessageCount.toString() : ''
              },
              {
                text: chatSummary.lastMessageText,
                customStyle: { maxWidth: '250px' },
              },
              {
                text: chatSummary.lastMessageDate ? formatDate(chatSummary.lastMessageDate) : '',
                align: 'right'
              },
            ],
          };

          newNoticeBoardList.push(noticeBoardItem);
        });

        setNoticeBoardList(newNoticeBoardList);
      })
      .catch(() => setError(true));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return <ErrorComponent type='contentFull' />;

  if (!chatList) return <Loading type='contentFull' />;

  return (
    <BaseContentContainer
      format={BaseContentContainerFormat.singleWithActionButtons}
      actionButtonPosition={BaseContentContainerActionButtonPosition.top}
    >
      <ButtonsBar pattern='together' sideAlign='left'>
        <FeatureTitle title='mensagens' />
      </ButtonsBar>

      {chatList.length > 0 ? (
        <List titles={titles} contents={chatList} />
      ) : (
        <Empty />
      )}
    </BaseContentContainer>
  );
};

export default ChatList;
